import { render, staticRenderFns } from "./CurrentPageComponents.vue?vue&type=template&id=d5fcca9a&scoped=true&"
import script from "./CurrentPageComponents.vue?vue&type=script&lang=js&"
export * from "./CurrentPageComponents.vue?vue&type=script&lang=js&"
import style0 from "./CurrentPageComponents.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CurrentPageComponents.vue?vue&type=style&index=1&id=d5fcca9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fcca9a",
  null
  
)

export default component.exports